// eslint-disable-next-line
const _dcq = _dcq || []
// eslint-disable-next-line
const _dcs = _dcs || {}
_dcs.account = '6794068';

(function () {
    const dc = document.createElement('script')
    dc.type = 'text/javascript'
    dc.async = true
    dc.src = '//tag.getdrip.com/6794068.js'
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(dc, s.nextSibling)
})()
